import * as React from 'react'
import { useState, useEffect } from 'react'
import { RenderElementProps } from 'slate-react'
import { Loader } from '../components'
import { ImageElement as ImageElementType } from '../slate'

const MAX_RETRIES = 10
const RETRY_TIMEOUT = 2000

const ImageElement = ({
  element,
  attributes,
  children
}: RenderElementProps & { element: ImageElementType }) => {
  const { mobileUrl, desktopUrl, rawUrl } = element
  const [isLoading, setIsLoading] = useState(true)
  const [retries, setRetries] = useState(0)
  const [timeout, startTimeout] = useState<any>(undefined)
  const [imageExtension, setImageExtension] = useState(Date.now)
  const [src, setSrc] = useState(desktopUrl)

  const initTimeout = () => {
    startTimeout(
      setTimeout(() => {
        setIsLoading(false)
      }, RETRY_TIMEOUT)
    )
  }
  useEffect(() => {
    initTimeout()
  }, [])
  const handleOnError = () => {
    if (retries >= MAX_RETRIES) {
      setSrc(rawUrl)
    } else {
      clearTimeout(timeout)
      setRetries(retries + 1)
      setTimeout(() => {
        initTimeout()
        setImageExtension(Date.now)
      }, 2000)
    }
  }
  return (
    <div
      className={`description-image-container ${isLoading ? 'is-loading' : ''}`}
      {...attributes}
    >
      <Loader isVisible={isLoading} classes='image-container-loader' />
      <img
        className={`${isLoading ? 'is-loading' : ''}`}
        src={`${src}?${imageExtension}`}
        srcSet={`${mobileUrl}?${imageExtension} 400w, ${desktopUrl}?${imageExtension} 890w`}
        onError={handleOnError}
        onClick={(e) => e.stopPropagation()}
      />
      {children}
    </div>
  )
}

export default ImageElement
